export enum UpdateMenuGroupPricesMode {
    IncreaseBasePrices = "increase_base_prices",
    SetByOptionName = "set_by_option_name",
    IncreaseByOptionName = "increase_by_option_name",
}
